export const toggle = el => collapse => {
  el.classList.remove('fix-175')
  el.classList.remove('fix-33')
  el.classList.add(collapse ? 'fix-175' : 'fix-33')
}

export const bind = function(el, _, vnode) {
  el.classList.add(
    document.querySelector('.sidebar.reduced') ? 'fix-33' : 'fix-175'
  )
  const toggleElement = toggle(el)
  vnode.context.$root.$on('menu:collapse', toggleElement)
}

export default { bind, toggle }
